import { useState } from 'react';

const BRAND_LOGO_KEY = 'osfn_brand_logo';
const PARTNER_LOGO_KEY = 'osfn_partner_logo';

const DEFAULT_BRAND_LOGO = `${import.meta.env.BASE_URL}brand-logo.png`;
const DEFAULT_PARTNER_LOGO = `${import.meta.env.BASE_URL}partner-logo.png`;

export const usePersistentLogos = () => {
  const [brandLogo, setBrandLogo] = useState<string>(() => {
    try {
      const storedLogo = window.localStorage.getItem(BRAND_LOGO_KEY);
      return storedLogo ? storedLogo : DEFAULT_BRAND_LOGO;
    } catch {
      return DEFAULT_BRAND_LOGO;
    }
  });

  const [partnerLogo, setPartnerLogo] = useState<string>(() => {
    try {
      const storedLogo = window.localStorage.getItem(PARTNER_LOGO_KEY);
      return storedLogo ? storedLogo : DEFAULT_PARTNER_LOGO;
    } catch {
      return DEFAULT_PARTNER_LOGO;
    }
  });

  const saveLogos = (newBrandLogo: string, newPartnerLogo: string) => {
    try {
      window.localStorage.setItem(BRAND_LOGO_KEY, newBrandLogo);
      setBrandLogo(newBrandLogo);

      window.localStorage.setItem(PARTNER_LOGO_KEY, newPartnerLogo);
      setPartnerLogo(newPartnerLogo);
    } catch {}
  };

  return { brandLogo, partnerLogo, saveLogos };
};